//#region \0rolldown/runtime.js
var e = Object.defineProperty, t = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, n = (t, n) => {
	let r = {};
	for (var i in t) e(r, i, {
		get: t[i],
		enumerable: !0
	});
	return n || e(r, Symbol.toStringTag, { value: "Module" }), r;
}, r = class extends HTMLElement {
	#e = null;
	#t = 0;
	connectedCallback() {
		this.#e ??= new AbortController();
	}
	disconnectedCallback() {
		this.#t++, this.#e?.abort(), this.#e = null;
	}
	listen(e, t, n, r) {
		this.#e ??= new AbortController(), e.addEventListener(t, n, {
			...r,
			signal: this.#e.signal
		});
	}
	whenParsed(e) {
		let t = this.#t, n = () => {
			t !== this.#t || !this.isConnected || e();
		};
		this.ownerDocument.readyState === "loading" ? (this.#e ??= new AbortController(), this.ownerDocument.addEventListener("DOMContentLoaded", n, {
			once: !0,
			signal: this.#e.signal
		})) : queueMicrotask(n);
	}
	upgradeProperty(e) {
		if (Object.prototype.hasOwnProperty.call(this, e)) {
			let t = this, n = t[e];
			delete t[e], t[e] = n;
		}
	}
	emit(e, t, n = !1) {
		return this.dispatchEvent(new CustomEvent(e, {
			detail: t,
			bubbles: !0,
			composed: !0,
			cancelable: n
		}));
	}
}, i = {
	OPEN: "pd:open",
	CLOSE: "pd:close",
	OPENED: "pd:opened",
	CLOSED: "pd:closed",
	FILTER: "pd:filter",
	NAVIGATE: "pd:navigate",
	SHOW: "pd:show",
	HIDE: "pd:hide",
	STICK: "pd:stick",
	UNSTICK: "pd:unstick"
};
//#endregion
//#region src/internal/animation.ts
async function a(e) {
	let t = (e.getAnimations?.({ subtree: !0 }) ?? []).filter((e) => e.effect?.getComputedTiming()?.iterations !== Infinity);
	t.length !== 0 && await Promise.allSettled(t.map((e) => e.finished));
}
//#endregion
//#region src/internal/utils.ts
var o = 0;
function s(e, t) {
	return e.id ||= `pd-${t}-${++o}`, e.id;
}
function c(e, t) {
	console.warn(`[pd-components] ${t}`, e);
}
function l(e, t) {
	for (let n = e; n; n = n.parentElement) if (n instanceof t) return n;
	return null;
}
function u(e) {
	let t = e.getRootNode();
	return t instanceof Document || t instanceof ShadowRoot ? t : null;
}
//#endregion
//#region src/internal/commands.ts
var d = {
	TOGGLE: "--pd-toggle",
	OPEN: "--pd-open",
	CLOSE: "--pd-close",
	DRILL: "--pd-drill",
	BACK: "--pd-back",
	FILTER: "--pd-filter",
	CLEAR: "--pd-clear",
	PREV: "--pd-prev",
	NEXT: "--pd-next",
	GOTO: "--pd-goto",
	SHOW_MODAL: "show-modal",
	DIALOG_CLOSE: "close"
};
function f(e) {
	return typeof e.command == "string" ? e : null;
}
function p(e) {
	let t = globalThis.CSS?.escape;
	return t ? t(e) : e.replace(/[\\"]/g, "\\$&");
}
function m(e) {
	if (!e.id) return [];
	let t = u(e);
	return t ? [...t.querySelectorAll(`button[commandfor="${p(e.id)}"]`)] : [];
}
function h(e) {
	return m(e).find((t) => {
		let n = t.getAttribute("command");
		return !e.contains(t) && !t.matches(":disabled") && t.tabIndex >= 0 && !t.closest("[hidden], [inert]") && (n === d.TOGGLE || n === d.OPEN);
	}) ?? null;
}
//#endregion
//#region src/internal/openable.ts
var g = class extends r {
	static observedAttributes = ["open"];
	idPrefix = "panel";
	#e = 0;
	#t = null;
	#n = !1;
	#r = null;
	connectedCallback() {
		super.connectedCallback(), this.upgradeProperty("open"), s(this, this.idPrefix), this.#a(this.open), this.whenParsed(() => {
			if (!this.isConnected) return;
			this.listen(this.commandTarget, "command", (e) => this.handleCommand(e)), this.#n = !0;
			let e = this.#t ?? "attribute";
			this.#t = null, this.#i(this.open, e, !0);
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#e++, this.#s(), this.#n = !1;
	}
	attributeChangedCallback(e, t, n) {
		if (e !== "open" || t === n) return;
		if (!this.#n) {
			this.isConnected && this.#a(n !== null);
			return;
		}
		let r = this.#t ?? "attribute";
		this.#t = null, this.#i(n !== null, r);
	}
	get open() {
		return this.hasAttribute("open");
	}
	set open(e) {
		this.toggleAttribute("open", e);
	}
	show(e = "api") {
		return this.open ? !0 : this.emit(i.OPEN, { reason: e }, !0) ? (this.#t = e, this.setAttribute("open", ""), !0) : !1;
	}
	hide(e = "api") {
		return this.open ? this.emit(i.CLOSE, { reason: e }, !0) ? (this.#t = e, this.removeAttribute("open"), !0) : !1 : !0;
	}
	toggle(e, t = "api") {
		return e ?? !this.open ? this.show(t) : this.hide(t);
	}
	get commandTarget() {
		return this;
	}
	get visualTarget() {
		return this;
	}
	get invokerTarget() {
		return this;
	}
	handleCommand(e) {
		let t = f(e);
		if (t) switch (t.command) {
			case d.TOGGLE:
				this.toggle(void 0, "command");
				break;
			case d.OPEN:
				this.show("command");
				break;
			case d.CLOSE: this.hide("command");
		}
	}
	#i(e, t, n = !1) {
		this.#e++, this.#l(e ? "open" : "closed"), this.#u(e), e ? (this.#s(), this.applyOpenVisual(t, n), n || (this.emit(i.OPENED, { reason: t }), this.onOpened(t))) : (this.#o(), n ? this.applyClosedVisual(t) : this.#c(this.#e, t));
	}
	#a(e) {
		if (this.#e++, this.#l(e ? "open" : "closed"), this.#u(e), e) {
			this.#s(), this.visualTarget.hidden = !1;
			return;
		}
		this.#o(), this.applyClosedVisual("attribute");
	}
	#o() {
		let e = this.visualTarget;
		this.#r && this.#r !== e && (this.#r.removeAttribute("inert"), this.#r = null), !e.hasAttribute("inert") && (e.setAttribute("inert", ""), this.#r = e);
	}
	#s() {
		let e = this.#r;
		e && (e.removeAttribute("inert"), this.#r = null);
	}
	async #c(e, t) {
		await a(this.visualTarget), !(e !== this.#e || this.open) && (this.applyClosedVisual(t), this.emit(i.CLOSED, { reason: t }), this.onClosed(t));
	}
	#l(e) {
		this.dataset.state = e, this.visualTarget !== this && (this.visualTarget.dataset.state = e);
	}
	#u(e) {
		for (let t of m(this.invokerTarget)) t.setAttribute("aria-expanded", String(e));
	}
	applyOpenVisual(e, t) {
		this.visualTarget.hidden = !1;
	}
	applyClosedVisual(e) {
		this.visualTarget.hidden = !0;
	}
	onOpened(e) {}
	onClosed(e) {}
}, _ = [
	"a[href]",
	"button:not([disabled])",
	"input:not([disabled]):not([type=\"hidden\"])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"[tabindex]:not([tabindex^=\"-\"])",
	"[contenteditable=\"\"]",
	"[contenteditable=\"true\"]",
	"audio[controls]",
	"video[controls]",
	"details > summary"
].join(", ");
function v(e) {
	return [...e.querySelectorAll(_)].filter((e) => {
		let t = e.getAttribute("tabindex");
		return !(t !== null && Number.parseInt(t, 10) < 0) && !e.matches(":disabled") && !e.closest("[hidden]") && !e.closest("[inert]");
	}).sort((e, t) => e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
}
function y(e) {
	for (let t of e.querySelectorAll("[autofocus]")) if (!(t.matches(":disabled") || t.closest("[hidden], [inert]")) && (t.focus(), t.ownerDocument.activeElement === t)) return !0;
	return !1;
}
function ee(e, t = !0) {
	if (t && y(e)) return !0;
	let n = v(e)[0];
	return n ? (n.focus(), !0) : !1;
}
function b(e) {
	try {
		return e.matches(":focus-visible");
	} catch {
		return !1;
	}
}
function x(e) {
	let t = e.activeElement;
	return t === null || t === e.body || t instanceof HTMLElement && t.tabIndex < 0 ? !1 : b(t);
}
function S(e) {
	return e instanceof HTMLElement && (e.matches("input, textarea, select") || e.isContentEditable);
}
//#endregion
//#region src/disclosure/disclosure.ts
var C = "h1, h2, h3, h4, h5, h6, [role=\"heading\"]", w = class e extends g {
	idPrefix = "disclosure";
	connectedCallback() {
		super.connectedCallback(), this.whenParsed(() => {
			if (!this.isConnected || !this.getAttribute("group")) return;
			this.#n();
			let e = m(this);
			e.length > 0 && !e.some((e) => e.closest(C)) && c(this, `accordion trigger for #${this.id} should be wrapped in a heading (APG accordion pattern)`);
		});
	}
	hide(e = "api") {
		return !this.#t() && super.hide(e);
	}
	onOpened(e) {
		let t = this.getAttribute("group");
		if (t) {
			for (let e of this.#e(t)) e !== this && e.open && e.hide("api");
			this.#n();
		}
	}
	onClosed(e) {
		this.getAttribute("group") && this.#n();
	}
	#e(t) {
		let n = u(this);
		return n ? [...n.querySelectorAll(this.localName)].filter((n) => n instanceof e && n.getAttribute("group") === t) : [this];
	}
	#t() {
		let e = this.getAttribute("group");
		if (!e || !this.open) return !1;
		let t = this.#e(e);
		return t.some((e) => e.getAttribute("collapsible") === "false") ? !t.some((e) => e !== this && e.open) : !1;
	}
	#n() {
		let e = this.getAttribute("group");
		if (!e) return;
		let t = this.#e(e), n = t.some((e) => e.getAttribute("collapsible") === "false"), r = t.filter((e) => e.open);
		for (let e of t) {
			let t = n && r.length === 1 && e === r[0];
			for (let n of m(e)) t ? n.setAttribute("aria-disabled", "true") : n.removeAttribute("aria-disabled");
		}
	}
};
//#endregion
//#region src/internal/context.ts
function T(e) {
	return Symbol(e);
}
var te = class extends Event {
	context;
	callback;
	subscribe;
	constructor(e, t, n = !1) {
		super("context-request", {
			bubbles: !0,
			composed: !0
		}), this.context = e, this.callback = t, this.subscribe = n;
	}
};
function E(e, t) {
	return (n) => {
		let r = n;
		r.context === e && typeof r.callback == "function" && (r.stopPropagation(), r.callback(t));
	};
}
function D(e, t) {
	let n = null;
	return e.dispatchEvent(new te(t, (e) => {
		n = e;
	})), n;
}
var O = T("pd-nav"), k = T("pd-drilldown"), A = T("pd-sticky-stack"), j = class extends g {
	idPrefix = "nav-panel";
	#e = null;
	connectedCallback() {
		super.connectedCallback();
		let e = D(this, O);
		e && (this.#e = e, e.register(this)), this.whenParsed(() => {
			this.isConnected && this.#t();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		let e = this.#e;
		this.#e = null, e?.unregister(this);
	}
	#t() {
		this.#e && (m(this).some((e) => {
			let t = e.getAttribute("command"), n = !1;
			for (let t = e; t; t = t.parentElement) {
				if (t.hasAttribute("hidden") || t.hasAttribute("inert")) {
					n = !0;
					break;
				}
				if (t === this.#e) break;
			}
			return !this.contains(e) && !e.matches(":disabled") && e.tabIndex >= 0 && !n && (t === d.TOGGLE || t === d.OPEN);
		}) || c(this, `<${this.localName}> has no button[commandfor] invoker outside itself; it cannot be opened by keyboard (WCAG 2.1.1)`));
	}
}, M = class e extends r {
	#e = null;
	#t = null;
	#n = !1;
	#r = /* @__PURE__ */ new Set();
	#i = null;
	connectedCallback() {
		super.connectedCallback(), this.listen(this, "context-request", E(O, this)), this.whenParsed(() => {
			this.isConnected && (this.listen(this, i.OPENED, (e) => this.#a(e)), this.listen(this, "keydown", (e) => this.#w(e)), this.listen(this, "pointerover", (e) => this.#d(e)), this.listen(this, "pointerleave", (e) => this.#f(e)), this.listen(this, "focusin", (e) => this.#v(e)), this.listen(this, "focusout", (e) => this.#y(e)), this.listen(this.ownerDocument, "pointerdown", (e) => this.#b(e)), this.listen(this.ownerDocument, "keydown", (e) => this.#S(e)));
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#h(), this.#g(), this.#r.clear(), this.#i = null;
	}
	register(e) {
		this.#r.has(e) || (this.#r.add(e), this.#i = null);
	}
	unregister(e) {
		this.#r.delete(e) && (this.#i = null);
	}
	#a(e) {
		let t = e.target;
		if (!(!(t instanceof j) || !this.#r.has(t))) for (let e of this.#s()) e !== t && e.hide("api");
	}
	get #o() {
		return this.#i ??= [...this.#r].sort((e, t) => e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1), this.#i.filter((e) => e.isConnected);
	}
	#s() {
		return this.#o.filter((e) => e.open);
	}
	#c(e) {
		if (!e) return null;
		let t = this.ownerDocument.getElementById(e);
		return t instanceof j && this.#r.has(t) ? t : null;
	}
	#l(e) {
		let t = e.closest("[commandfor]");
		if (t) {
			let e = t.getAttribute("command");
			if (e === d.TOGGLE || e === d.OPEN) {
				let e = this.#c(t.getAttribute("commandfor") ?? "");
				if (e) return e;
			}
		}
		let n = e.closest("[data-pd-hover-for]");
		if (n) {
			let e = this.#c(n.getAttribute("data-pd-hover-for") ?? "");
			if (e) return e;
		}
		return null;
	}
	#u(e) {
		let t = this.#l(e);
		if (t) return t;
		for (let t = l(e, j); t; t = l(t.parentElement, j)) if (this.#r.has(t)) return t;
		return null;
	}
	#d(e) {
		if (!this.hasAttribute("hover") || e.pointerType !== "mouse" || !(e.target instanceof Element)) return;
		let t = this.#u(e.target);
		if (this.#g(), !t) {
			this.#m();
			return;
		}
		if (t.open) {
			this.#h();
			return;
		}
		this.#p(t);
	}
	#f(e) {
		!this.hasAttribute("hover") || e.pointerType !== "mouse" || (this.#h(), this.#m());
	}
	#p(e) {
		this.#h();
		let t = this.#_("hover-open-delay", 100);
		this.#e = setTimeout(() => {
			this.#e = null, e.show("hover");
		}, t);
	}
	#m() {
		if (this.#t !== null) return;
		let e = this.#_("hover-close-delay", 200);
		this.#t = setTimeout(() => {
			this.#t = null;
			let e = this.ownerDocument.activeElement, t = e instanceof Element ? this.#u(e) : null;
			for (let e of this.#s()) e !== t && e.hide("hover");
		}, e);
	}
	#h() {
		this.#e !== null && (clearTimeout(this.#e), this.#e = null);
	}
	#g() {
		this.#t !== null && (clearTimeout(this.#t), this.#t = null);
	}
	#_(e, t) {
		let n = this.getAttribute(e), r = n === null ? NaN : Number(n);
		return Number.isFinite(r) ? r : t;
	}
	#v(t) {
		if (this.#n || !(t.target instanceof Element) || l(t.target, e) !== this) return;
		let n = this.#u(t.target), r = b(t.target);
		if (r && (this.#h(), this.#g()), this.hasAttribute("open-on-focus") && r && n) {
			n.open || n.show("focus");
			return;
		}
		if (this.getAttribute("close-on-focusout") !== "false") for (let e of this.#s()) e !== n && e.hide("focusout");
	}
	#y(e) {
		if (this.getAttribute("close-on-focusout") === "false") return;
		let t = e.relatedTarget;
		queueMicrotask(() => {
			if (!this.isConnected) return;
			let e = t ?? this.ownerDocument.activeElement;
			if (!(e instanceof Node && this.contains(e))) for (let e of this.#s()) e.hide("focusout");
		});
	}
	#b(e) {
		let t = e.target;
		if (!(t instanceof Node && this.contains(t))) for (let e of this.#s()) e.hide("outside");
	}
	#x() {
		return v(this).filter((t) => {
			let n = l(t, j);
			return t.matches("a[href], button") && !(n && this.#r.has(n)) && l(t, e) === this;
		});
	}
	#S(t) {
		if (t.key !== "Escape" || t.defaultPrevented) return;
		let n = this.ownerDocument.activeElement, r = [];
		try {
			r = [...this.ownerDocument.querySelectorAll("dialog:modal")];
		} catch {
			let e = n instanceof Element ? n.closest("dialog[open]") : null;
			e && (r = [e]);
		}
		if (r.length > 0 && !r.some((e) => e.contains(this))) return;
		if (n instanceof Element) {
			for (let t = l(n, e); t; t = l(t.parentElement, e)) if (t.#s().length !== 0) {
				if (t !== this && !t.contains(this)) return;
				break;
			}
		}
		for (let t of this.querySelectorAll("*")) if (t instanceof e && t.#s().length > 0) return;
		let i = this.#s()[0];
		if (!i) return;
		t.preventDefault();
		let a = n instanceof Node && this.contains(n);
		if (i.hide("escape") && a) {
			let e = h(i);
			e && this.#C(e);
		}
	}
	#C(e) {
		this.#n = !0;
		try {
			e.focus();
		} finally {
			queueMicrotask(() => {
				this.#n = !1;
			});
		}
	}
	#w(t) {
		if (t.defaultPrevented || this.getAttribute("arrow-nav") === "false" || S(t.target) || !(t.target instanceof Element)) return;
		let n = t.target;
		if (l(n, e) !== this) return;
		let r = this.getAttribute("orientation") === "vertical", i = r ? "ArrowDown" : "ArrowRight", a = r ? "ArrowUp" : "ArrowLeft", o = r ? "ArrowRight" : "ArrowDown", s = r ? "ArrowLeft" : "ArrowUp";
		if (t.key === "Home" || t.key === "End") {
			let e = this.#x();
			if (e.indexOf(n) === -1) return;
			(t.key === "Home" ? e[0] : e[e.length - 1])?.focus(), t.preventDefault();
			return;
		}
		if (t.key === i || t.key === a) {
			let e = this.#x(), r = e.indexOf(n);
			if (r === -1) return;
			let a = e[r + (t.key === i ? 1 : -1)];
			if (!a) return;
			a.focus(), t.preventDefault();
			return;
		}
		if (t.key === o) {
			let e = this.#l(n);
			if (e) {
				t.preventDefault(), e.show("keyboard") && v(e)[0]?.focus();
				return;
			}
			let r = l(n, j);
			if (r?.open) {
				t.preventDefault();
				let e = v(r);
				e[e.indexOf(n) + 1]?.focus();
			}
			return;
		}
		if (t.key === s) {
			let e = this.#l(n);
			if (e) {
				e.open && (t.preventDefault(), e.hide("keyboard"));
				return;
			}
			let r = l(n, j);
			if (r?.open) {
				t.preventDefault();
				let e = v(r);
				e[e.indexOf(n) - 1]?.focus();
			}
			return;
		}
	}
}, N = 0, P = "", F = "";
function I(e, t, n) {
	n ? e.style.setProperty(t, n) : e.style.removeProperty(t);
}
function L(e) {
	N++ === 0 && (P = e.style.getPropertyValue("overflow"), F = e.style.getPropertyValue("scrollbar-gutter"), e.style.setProperty("scrollbar-gutter", "stable"), e.style.setProperty("overflow", "clip"));
}
function R(e) {
	N > 0 && --N === 0 && (I(e, "overflow", P), I(e, "scrollbar-gutter", F));
}
var z = class extends g {
	idPrefix = "drawer";
	#e = null;
	#t = null;
	#n = null;
	#r = !1;
	#i = !1;
	connectedCallback() {
		this.hasAttribute("inert") || (this.setAttribute("inert", ""), this.#i = !0), this.whenParsed(() => {
			if (this.isConnected) {
				if (this.#e = this.querySelector("dialog"), !this.#e) {
					c(this, `<${this.localName}> needs a <dialog> descendant; staying inert`);
					return;
				}
				this.#l(), s(this.#e, `${this.idPrefix}-dialog`), this.listen(this.#e, "cancel", (e) => {
					e.preventDefault(), this.hide("escape");
				}), this.listen(this.#e, "pointerdown", (e) => this.#u(e));
			}
		}), super.connectedCallback();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#l(), this.#c(), this.#e?.open && this.#e.close(), this.#e = null, this.open || (this.#t = null), this.#n = null;
	}
	get commandTarget() {
		return this.#e ?? this;
	}
	get visualTarget() {
		return this.#e ?? this;
	}
	get invokerTarget() {
		return this.#e ?? this;
	}
	handleCommand(e) {
		if (!this.#e) return;
		let t = f(e);
		if (t) {
			(t.command === d.SHOW_MODAL || t.command === d.OPEN || t.command === d.TOGGLE && !this.open) && t.source instanceof HTMLElement && (this.#n = t.source);
			try {
				switch (t.command) {
					case d.SHOW_MODAL:
						t.preventDefault(), this.show("command");
						break;
					case d.DIALOG_CLOSE:
						t.preventDefault(), this.hide("command");
						break;
					default: super.handleCommand(e);
				}
			} finally {
				this.#n = null;
			}
		}
	}
	applyOpenVisual(e, t) {
		let n = this.#e;
		if (!n) {
			this.hasAttribute("inert") || (this.setAttribute("inert", ""), this.#i = !0);
			return;
		}
		let r = x(this.ownerDocument);
		if (this.#t ??= this.#n ?? this.ownerDocument.activeElement, this.#s(), !n.open) try {
			n.showModal();
		} catch {}
		r ? ee(n) || this.#a(n) : y(n) || this.#a(n);
	}
	#a(e) {
		e.hasAttribute("tabindex") || (e.tabIndex = -1), e.focus({ preventScroll: !0 });
	}
	applyClosedVisual(e) {
		let t = this.#e;
		t && (t.open && t.close(), this.#c(), this.#o(t));
	}
	#o(e) {
		let t = this.#t;
		if (this.#t = null, !(t instanceof HTMLElement) || !t.isConnected) return;
		let n = this.ownerDocument.activeElement;
		(n === null || n === this.ownerDocument.body || e.contains(n)) && t.focus();
	}
	#s() {
		this.#r || this.getAttribute("scroll-lock") === "false" || (this.#r = !0, L(this.ownerDocument.documentElement));
	}
	#c() {
		this.#r && (this.#r = !1, R(this.ownerDocument.documentElement));
	}
	#l() {
		this.#i &&= (this.removeAttribute("inert"), !1);
	}
	#u(e) {
		let t = this.#e;
		if (!t || e.target !== t || this.getAttribute("close-on-outside-click") === "false") return;
		let { clientX: n = 0, clientY: r = 0 } = e, i = t.getBoundingClientRect();
		n >= i.left && n <= i.right && r >= i.top && r <= i.bottom || this.hide("outside");
	}
}, B = class extends r {
	static observedAttributes = ["label"];
	#e = null;
	connectedCallback() {
		super.connectedCallback();
		let e = D(this, k);
		e && (this.#e = e, e.register(this)), s(this, "drilldown-panel"), this.whenParsed(() => {
			this.isConnected && this.#t();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		let e = this.#e;
		this.#e = null, e?.unregister(this);
	}
	attributeChangedCallback(e, t, n) {
		e === "label" && t !== n && this.#t();
	}
	#t() {
		let e = this.getAttribute("label");
		e === null ? (this.removeAttribute("aria-label"), this.getAttribute("role") === "group" && this.removeAttribute("role")) : (this.setAttribute("role", "group"), this.setAttribute("aria-label", e));
	}
}, V = class extends r {
	#e = null;
	#t = null;
	#n = [];
	#r = /* @__PURE__ */ new WeakSet();
	#i = /* @__PURE__ */ new WeakMap();
	#a = /* @__PURE__ */ new WeakSet();
	#o = /* @__PURE__ */ new Set();
	#s = null;
	#c = !1;
	connectedCallback() {
		super.connectedCallback(), this.listen(this, "context-request", E(k, this)), s(this, "drilldown"), this.whenParsed(() => {
			this.isConnected && this.#u();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		for (let e of this.#o) this.#S(e);
		this.#r = /* @__PURE__ */ new WeakSet(), this.#n = [], this.#e = null, this.#t = null, this.#c = !1, this.#o.clear(), this.#s = null;
	}
	register(e) {
		this.#o.has(e) || (this.#o.add(e), this.#s = null, this.#e === null ? (this.#e = e, this.#t = e, this.#_(e)) : !this.#c && e.hasAttribute("root") && !this.#e.hasAttribute("root") ? (this.#t && this.#v(this.#t, !0), this.#e = e, this.#t = e, this.#_(e)) : (this.#c && e.hasAttribute("root") && !this.#e.hasAttribute("root") && (this.#e = e), this.#v(e, !0)));
	}
	unregister(e) {
		if (!this.#o.delete(e)) return;
		let t = e === this.#e, n = e === this.#t;
		if (this.#S(e), this.#s = null, !t && !n) return;
		this.#n = [], delete this.dataset.direction;
		let r = this.#l, i = r.find((e) => e.hasAttribute("root")) ?? r[0] ?? null;
		t && (this.#e = !n && this.#t && this.#o.has(this.#t) ? this.#t : i), n && (this.#t = this.#e ?? i, this.#t && this.#_(this.#t)), this.#t && this.#w(this.#t);
	}
	get #l() {
		return this.#s ??= [...this.#o].sort((e, t) => e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1), this.#s.filter((e) => e.isConnected);
	}
	refresh() {
		for (let e of this.#l) this.#r.has(e) || (this.#d(e), e !== this.#t && this.#v(e, !0));
	}
	reset() {
		let e = this.#e;
		if (!e) return;
		let t = this.#t, n = this.ownerDocument.activeElement, r = t !== null && n !== null && (n === t || t.contains(n)), a = r && x(this.ownerDocument);
		this.#n = [], delete this.dataset.direction, t && t !== e && (this.#v(t), this.#_(e), this.#t = e), this.#w(e), r && t !== e && this.#C(e, a), this.emit(i.NAVIGATE, {
			panelId: e.id,
			direction: "reset"
		});
	}
	#u() {
		this.#c = !0;
		let e = this.#l;
		if (e.length === 0) {
			c(this, `<${this.localName}> needs at least one drilldown-panel child`);
			return;
		}
		let t = e.find((e) => e.hasAttribute("root")) ?? e[0];
		this.#e = t, this.#t = t;
		for (let n of e) this.#d(n), n === t ? this.#_(n) : this.#v(n, !0);
		this.listen(this, "command", (e) => this.#f(e)), this.#w(t);
	}
	#d(e) {
		this.#r.has(e) || (this.#r.add(e), this.listen(e, "command", (t) => this.#p(e, t)));
	}
	#f(e) {
		let t = f(e);
		!t || t.command !== d.BACK || this.#h();
	}
	#p(e, t) {
		if (!this.#o.has(e)) return;
		let n = f(t);
		if (n) switch (n.command) {
			case d.DRILL:
				this.#m(e, n.source);
				break;
			case d.BACK: e === this.#t && this.#h();
		}
	}
	#m(e, t) {
		let n = this.#t;
		if (!n || n === e) return;
		let r = x(this.ownerDocument);
		this.dataset.direction = "forward", this.#n.push({
			fromId: n.id,
			invoker: t
		}), this.#v(n), this.#_(e), this.#t = e, this.#w(e), this.#C(e, r), this.emit(i.NAVIGATE, {
			panelId: e.id,
			direction: "forward"
		});
	}
	#h() {
		let e = this.#n.pop();
		if (!e) return;
		let t = this.#l.find((t) => t.id === e.fromId);
		if (!t) {
			c(this, `drilldown lost track of panel #${e.fromId}`);
			return;
		}
		let n = x(this.ownerDocument);
		this.dataset.direction = "back";
		let r = this.#t;
		r && r !== t && this.#v(r), this.#_(t), this.#t = t, this.#w(t), n && e.invoker instanceof HTMLElement && e.invoker.isConnected ? e.invoker.focus({ preventScroll: !0 }) : this.#C(t, n), this.emit(i.NAVIGATE, {
			panelId: t.id,
			direction: "back"
		});
	}
	#g(e) {
		let t = (this.#i.get(e) ?? 0) + 1;
		return this.#i.set(e, t), t;
	}
	#_(e) {
		this.#g(e), e.dataset.state = "active", this.#x(e), e.hidden = !1;
	}
	#v(e, t = !1) {
		let n = this.#g(e);
		if (e.dataset.state = "inactive", this.#b(e), t) {
			e.hidden = !0;
			return;
		}
		this.#y(e, n);
	}
	async #y(e, t) {
		await a(e), this.#i.get(e) === t && (e.hidden = !0);
	}
	#b(e) {
		e.hasAttribute("inert") || (e.setAttribute("inert", ""), this.#a.add(e));
	}
	#x(e) {
		this.#a.delete(e) && e.removeAttribute("inert");
	}
	#S(e) {
		this.#g(e), this.#x(e);
	}
	#C(e, t = x(this.ownerDocument)) {
		if (t) {
			let t = v(e)[0];
			if (t) {
				t.focus({ preventScroll: !0 });
				return;
			}
		}
		e.hasAttribute("tabindex") || e.setAttribute("tabindex", "-1"), e.focus({ preventScroll: !0 });
	}
	#w(e) {
		let t = this.#n.length > 0;
		for (let n of e.querySelectorAll(`button[command="${d.BACK}"]`)) n.hidden = !t;
	}
};
//#endregion
//#region src/filter/filter.ts
function H(e) {
	return e.normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase().trim();
}
function U(e) {
	return e.split(",").map((e) => H(e)).filter((e) => e.length > 0);
}
function W(e, t, n) {
	switch (n) {
		case "equals": return e === t;
		case "includes": return e.includes(t);
		default: return e.startsWith(t);
	}
}
function G(e, t, n) {
	return t.some((t) => W(e, t, n));
}
function K(e) {
	let t = [...e.querySelectorAll("[data-filter-item]")];
	return t.length > 0 ? t : [...e.children];
}
function q(e) {
	return H(e.getAttribute("data-filter-value") ?? e.textContent ?? "");
}
var J = class extends r {
	static observedAttributes = ["value"];
	#e = null;
	#t = null;
	#n = null;
	#r = 0;
	#i = 0;
	#a = !1;
	#o = !1;
	connectedCallback() {
		super.connectedCallback(), this.upgradeProperty("value"), s(this, "filter"), this.whenParsed(() => {
			this.isConnected && (this.#d(), this.listen(this, "command", (e) => this.#s(e)), this.#a = !0, this.#c(this.getAttribute("value"), !0));
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#t?.disconnect(), this.#t = null, this.#a = !1;
	}
	attributeChangedCallback(e, t, n) {
		e === "value" && t !== n && (!this.#a || this.#o || this.#c(n));
	}
	get value() {
		return this.#n;
	}
	set value(e) {
		this.apply(e);
	}
	get count() {
		return this.#r;
	}
	get total() {
		return this.#i;
	}
	apply(e) {
		this.#c(e);
	}
	clear() {
		this.apply(null);
	}
	refresh() {
		this.#d(), this.#f();
	}
	#s(e) {
		let t = f(e);
		if (t) switch (t.command) {
			case d.FILTER: {
				let e = t.source?.getAttribute("value") ?? null;
				if (e === null) break;
				this.getAttribute("toggle") !== "false" && this.#n === e ? this.clear() : this.apply(e);
				break;
			}
			case d.CLEAR: this.clear();
		}
	}
	#c(e, t = !1) {
		if (this.#n = e, this.#f(), this.#l(e), !t) {
			let t = {
				value: e,
				count: this.#r,
				total: this.#i
			};
			this.emit(i.FILTER, t);
		}
	}
	#l(e) {
		this.#o = !0, e === null ? this.removeAttribute("value") : this.setAttribute("value", e), this.#o = !1;
	}
	get #u() {
		let e = this.getAttribute("match");
		return e === "equals" || e === "includes" ? e : "starts-with";
	}
	#d() {
		let e = this.getAttribute("for"), t = u(this), n = e && t ? t.getElementById(e) : null;
		if (!n) {
			c(this, `<${this.localName}> needs [for] pointing to an existing list; staying inert`), this.#t?.disconnect(), this.#t = null, this.#e = null;
			return;
		}
		n !== this.#e && (this.#t?.disconnect(), this.#e = n, this.#t = new MutationObserver(() => this.refresh()), this.#t.observe(n, { childList: !0 }));
	}
	#f() {
		let e = this.#e, t = e ? K(e) : [], n = this.#u, r = t.map(q), i = this.#n, a = i === null ? null : U(i), o = 0;
		t.forEach((e, t) => {
			let i = a === null || G(r[t], a, n);
			i && o++, e.toggleAttribute("hidden", !i), e.setAttribute("data-state", i ? "shown" : "hidden");
		}), this.#i = t.length, this.#r = o;
		let s = this.ownerDocument.activeElement, c = null;
		for (let e of m(this)) {
			if (e.getAttribute("command") !== d.FILTER) continue;
			let t = e.getAttribute("value") ?? "", a = U(t), o = r.some((e) => G(e, a, n));
			!o && e === s && (c = e), e.disabled = !o, e.toggleAttribute("data-empty", !o), e.setAttribute("aria-pressed", String(i !== null && t === i));
		}
		c && this.#p(c);
	}
	#p(e) {
		let t = m(this), n = t.filter((e) => e.getAttribute("command") === d.FILTER), r = n.indexOf(e);
		(n.slice(r + 1).find((e) => !e.disabled) ?? n.slice(0, Math.max(r, 0)).reverse().find((e) => !e.disabled) ?? t.find((e) => e.getAttribute("command") === d.CLEAR && !e.disabled))?.focus();
	}
}, Y = class extends r {
	#e = "";
	#t = null;
	connectedCallback() {
		super.connectedCallback(), this.whenParsed(() => {
			if (!this.isConnected) return;
			this.setAttribute("role", "status"), this.#e = this.textContent ?? "", this.#t = this.getAttribute("for");
			let e = this.#n();
			if (!e) {
				c(this, `<${this.localName}> needs [for] pointing to an existing pd-filter`);
				return;
			}
			this.#i(e.value, e.count, e.total);
			let t = u(this);
			t && this.listen(t, i.FILTER, (e) => this.#r(e));
		});
	}
	#n() {
		let e = this.#t, t = u(this);
		if (!e || !t) return null;
		let n = t.getElementById(e);
		return n instanceof J ? n : null;
	}
	#r(e) {
		let t = e.target;
		if (!(t instanceof Element) || t.id !== this.#t) return;
		let { value: n, count: r, total: i } = e.detail;
		this.#i(n, r, i);
	}
	#i(e, t, n) {
		this.textContent = this.#e.replaceAll("{count}", String(t)).replaceAll("{total}", String(n)).replaceAll("{value}", e ?? "");
	}
}, X = 8, Z = class extends r {
	static observedAttributes = ["pinned"];
	#e = !0;
	#t = 0;
	#n = !1;
	#r = !1;
	connectedCallback() {
		super.connectedCallback(), this.upgradeProperty("pinned"), this.#t = this.#i, this.dataset.state = "visible", this.#d(this.#t <= 2), this.listen(window, "scroll", () => this.#c(), { passive: !0 }), this.listen(this, "focusin", () => {
			this.#r = !0, this.#e || this.#f(!0);
		}), this.listen(this, "focusout", (e) => this.#s(e));
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#n = !1;
	}
	attributeChangedCallback(e, t, n) {
		e === "pinned" && t !== n && n !== null && !this.#e && this.#f(!0);
	}
	get pinned() {
		return this.hasAttribute("pinned");
	}
	set pinned(e) {
		this.toggleAttribute("pinned", e);
	}
	pin() {
		this.pinned = !0;
	}
	unpin() {
		this.pinned = !1;
	}
	get #i() {
		return window.scrollY || 0;
	}
	get #a() {
		let e = Number(this.getAttribute("threshold"));
		return this.hasAttribute("threshold") && Number.isFinite(e) && e >= 0 ? e : X;
	}
	get #o() {
		let e = Number(this.getAttribute("min-y"));
		return this.hasAttribute("min-y") && Number.isFinite(e) && e >= 0 ? e : this.offsetHeight;
	}
	#s(e) {
		let t = e.relatedTarget ?? this.ownerDocument.activeElement;
		(!(t instanceof Node) || !this.contains(t)) && (this.#r = !1);
	}
	#c() {
		if (this.#n) return;
		this.#n = !0;
		let e = window.requestAnimationFrame;
		typeof e == "function" ? e.call(window, () => this.#l()) : this.#l();
	}
	#l() {
		this.#n = !1;
		let e = this.#i, t = e <= 2;
		if (this.#d(t), t) {
			this.#t = e, this.#f(!0);
			return;
		}
		let n = e - this.#t;
		if (!(Math.abs(n) < this.#a)) {
			if (this.#t = e, n < 0) {
				this.#f(!0);
				return;
			}
			e > this.#o && !this.#u() && this.#f(!1);
		}
	}
	#u() {
		return this.#r || this.pinned || this.querySelector("[open], [data-state=\"open\"]") !== null;
	}
	#d(e) {
		this.toggleAttribute("data-at-top", e);
	}
	#f(e) {
		if (this.#e === e) return;
		this.#e = e, this.dataset.state = e ? "visible" : "hidden";
		let t = { y: this.#i };
		this.emit(e ? i.SHOW : i.HIDE, t);
	}
}, Q = 0, $ = class extends r {
	static observedAttributes = ["level"];
	#e = null;
	#t = !1;
	#n = null;
	connectedCallback() {
		super.connectedCallback(), s(this, "sticky");
		let e = D(this, A);
		e && (this.#e = e, e.register(this)), this.whenParsed(() => {
			this.isConnected && (this.#e || (c(this, `<${this.localName}> has no ancestor <pd-sticky-stack>; staying at a 0px offset`), this.applyOffset(0)));
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		let e = this.#e;
		this.#e = null, e?.unregister(this);
	}
	attributeChangedCallback(e, t, n) {
		e === "level" && t !== n && this.#e?.recompute();
	}
	get level() {
		let e = this.getAttribute("level");
		if (e === null) return Q;
		let t = Number(e);
		return Number.isInteger(t) && t >= 0 ? t : Q;
	}
	applyOffset(e) {
		let t = Math.round(e * 10) / 10;
		this.#n !== t && (this.#n = t, this.style.setProperty("--pd-sticky-top", `${t}px`));
	}
	setStuck(e) {
		if (this.#t === e) return;
		this.#t = e, this.toggleAttribute("data-stuck", e);
		let t = { level: this.level };
		this.emit(e ? i.STICK : i.UNSTICK, t);
	}
	visibleBottom() {
		let e = -Infinity;
		for (let t of this.children) e = Math.max(e, t.getBoundingClientRect().bottom);
		return e === -Infinity ? this.getBoundingClientRect().bottom : e;
	}
}, ne = {
	disclosure: w,
	nav: M,
	"nav-panel": j,
	drawer: z,
	drilldown: V,
	"drilldown-panel": B,
	filter: J,
	"filter-status": Y,
	header: Z,
	"sticky-stack": class e extends r {
		#e = null;
		#t = !1;
		#n = 0;
		#r = !1;
		#i = null;
		#a = !1;
		#o = /* @__PURE__ */ new Set();
		#s = null;
		connectedCallback() {
			if (super.connectedCallback(), this.listen(this, "context-request", E(A, this)), this.#a = l(this.parentElement, e) !== null, this.#a) {
				c(this, `<${this.localName}> cannot be nested inside another <pd-sticky-stack>; staying inert`);
				return;
			}
			this.whenParsed(() => {
				this.isConnected && (this.#l(), this.recompute());
			});
		}
		disconnectedCallback() {
			super.disconnectedCallback(), this.#e?.disconnect(), this.#e = null, this.#t = !1, this.#n = 0, this.#r = !1, this.#i = null, this.#o.clear(), this.#s = null, this.ownerDocument.documentElement.style.removeProperty("--pd-stack-height");
		}
		register(e) {
			this.#o.has(e) || (this.#o.add(e), this.#s = null, this.recompute());
		}
		unregister(e) {
			this.#o.delete(e) && (this.#s = null, this.#e?.unobserve(e), this.recompute());
		}
		recompute() {
			if (this.#a || !this.isConnected) return;
			let e = this.#c, t = /* @__PURE__ */ new Map();
			for (let n of e) {
				this.#e?.observe(n);
				let e = 0;
				for (let [r, i] of t) r < n.level && (e = Math.max(e, i));
				e = Math.max(0, e), n.applyOffset(e);
				let r = n.getBoundingClientRect(), i = r.top <= e + 1 && r.bottom > e;
				if (n.setStuck(i), i) {
					t.set(n.level, Math.max(e, n.visibleBottom()));
					for (let e of [...t.keys()]) e > n.level && t.delete(e);
				}
			}
			this.#h(Math.max(0, ...t.values()));
		}
		get #c() {
			return this.#s ??= [...this.#o].sort((e, t) => e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1), this.#s.filter((e) => e.isConnected);
		}
		#l() {
			this.listen(window, "scroll", () => this.#u(), { passive: !0 }), typeof ResizeObserver < "u" && (this.#e = new ResizeObserver(() => this.recompute()));
			let e = (e) => e.target instanceof Element && l(e.target, $) !== null, t = (t) => {
				e(t) && this.#d();
			}, n = (t) => {
				e(t) && this.#f();
			};
			this.listen(this, "transitionrun", t), this.listen(this, "transitionend", n), this.listen(this, "transitioncancel", n), this.listen(this, "animationstart", t), this.listen(this, "animationend", n), this.listen(this, "animationcancel", n);
		}
		#u() {
			if (this.#t) return;
			this.#t = !0;
			let e = window.requestAnimationFrame;
			typeof e == "function" ? e.call(window, () => {
				this.#t = !1, this.recompute();
			}) : (this.#t = !1, this.recompute());
		}
		#d() {
			this.#n++, this.#p();
		}
		#f() {
			this.#n > 0 && this.#n--;
		}
		#p() {
			if (this.#r) return;
			this.#r = !0;
			let e = () => {
				if (!this.isConnected) {
					this.#r = !1;
					return;
				}
				this.recompute(), this.#n > 0 ? this.#m(e) : this.#r = !1;
			};
			this.#m(e);
		}
		#m(e) {
			let t = window.requestAnimationFrame;
			typeof t == "function" ? t.call(window, e) : e(0);
		}
		#h(e) {
			let t = Math.round(e * 10) / 10;
			if (this.#i === t) return;
			this.#i = t;
			let n = `${t}px`;
			this.style.setProperty("--pd-stack-height", n), this.ownerDocument.documentElement.style.setProperty("--pd-stack-height", n);
		}
	},
	sticky: $,
	"dynamic-grid": class e extends r {
		#e = null;
		#t = !1;
		#n = null;
		#r = null;
		#i = "";
		#a = "";
		#o = /* @__PURE__ */ new WeakMap();
		connectedCallback() {
			super.connectedCallback(), this.whenParsed(() => {
				if (!this.isConnected) return;
				this.#e = this.querySelector("[data-scroller]") ?? this.querySelector("ul, ol");
				let e = this.#e;
				if (!e) {
					c(this, `<${this.localName}> needs a [data-scroller] or list descendant; staying inert`);
					return;
				}
				s(e, "grid"), e.hasAttribute("tabindex") || (e.tabIndex = 0), !e.hasAttribute("role") && !/^(ul|ol)$/i.test(e.tagName) && e.setAttribute("role", "group");
				let t = this.getAttribute("label");
				t && !e.hasAttribute("aria-label") && !e.hasAttribute("aria-labelledby") && e.setAttribute("aria-label", t), !e.hasAttribute("aria-label") && !e.hasAttribute("aria-labelledby") && c(this, `scroller #${e.id} has no accessible name — set label= or aria-label`), this.#s(e), this.listen(e, "command", (e) => this.#c(e)), this.listen(e, "scroll", () => this.#m(), { passive: !0 });
				let n = () => {
					this.#r = null;
				};
				this.listen(e, "wheel", n, { passive: !0 }), this.listen(e, "touchstart", n, { passive: !0 }), this.listen(e, "pointerdown", n, { passive: !0 }), this.listen(e, "scrollend", n), typeof ResizeObserver < "u" && (this.#n = new ResizeObserver(() => this.#h()), this.#n.observe(e)), this.#h();
			});
		}
		disconnectedCallback() {
			super.disconnectedCallback(), this.#n?.disconnect(), this.#n = null, this.#e = null, this.#t = !1, this.#r = null;
		}
		refresh() {
			this.#h();
		}
		#s(t) {
			let n = [
				d.PREV,
				d.NEXT,
				d.GOTO
			].map((e) => `button[command="${e}"]:not([commandfor])`).join(", ");
			for (let r of this.querySelectorAll(n)) l(r, e) === this && r.setAttribute("commandfor", t.id);
		}
		#c(e) {
			let t = f(e);
			if (t && t.source?.getAttribute("aria-disabled") !== "true") {
				if (t.command === d.PREV) this.#f(-1);
				else if (t.command === d.NEXT) this.#f(1);
				else if (t.command === d.GOTO) {
					let e = Number.parseInt(t.source?.getAttribute("value") ?? "", 10);
					Number.isInteger(e) && this.#d(e);
				}
			}
		}
		#l(e) {
			return [...e.children].filter((e) => e instanceof HTMLElement);
		}
		#u(e, t) {
			let n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
			return this.#p(e) ? e.scrollLeft + (r.right - n.right) : e.scrollLeft + (r.left - n.left);
		}
		#d(e) {
			let t = this.#e;
			if (!t) return;
			let n = this.#l(t), r = n[Math.max(0, Math.min(n.length - 1, e))];
			r && (this.#r = this.#u(t, r), typeof t.scrollTo == "function" ? t.scrollTo({
				left: this.#r,
				behavior: "auto"
			}) : t.scrollLeft = this.#r, this.#h());
		}
		#f(e) {
			let t = this.#e;
			if (!t) return;
			let n = this.#p(t), r = t.scrollWidth - t.clientWidth, i = (this.#r ?? t.scrollLeft) + e * t.clientWidth * (n ? -1 : 1), a = n ? Math.min(0, Math.max(-r, i)) : Math.max(0, Math.min(r, i));
			this.#r = a, typeof t.scrollTo == "function" ? t.scrollTo({
				left: a,
				behavior: "auto"
			}) : t.scrollLeft = a, this.#h();
		}
		#p(e) {
			let t = this.ownerDocument.defaultView;
			return t ? t.getComputedStyle(e).direction === "rtl" : !1;
		}
		#m() {
			if (this.#t) return;
			this.#t = !0;
			let e = typeof window < "u" ? window.requestAnimationFrame : void 0;
			typeof e == "function" ? e.call(window, () => {
				this.#t = !1, this.#h();
			}) : (this.#t = !1, this.#h());
		}
		#h() {
			let e = this.#e;
			if (!e) return;
			this.#r !== null && Math.abs(e.scrollLeft - this.#r) <= 1 && (this.#r = null);
			let t = e.scrollWidth - e.clientWidth, n = Math.abs(e.scrollLeft), r = t <= 1 || n <= 1, i = t <= 1 || n >= t - 1;
			this.toggleAttribute("data-at-start", r), this.toggleAttribute("data-at-end", i);
			let a = (t > 1 ? Math.min(1, n / t) : 0).toFixed(4), o = (e.scrollWidth > 0 ? Math.min(1, e.clientWidth / e.scrollWidth) : 1).toFixed(4);
			a !== this.#i && (this.#i = a, this.style.setProperty("--pd-scroll-progress", a)), o !== this.#a && (this.#a = o, this.style.setProperty("--pd-scroll-extent", o));
			let s = m(e), c = [];
			for (let e of s) {
				let t = e.getAttribute("command");
				t === d.PREV ? this.#_(e, r) : t === d.NEXT ? this.#_(e, i) : t === d.GOTO && c.push(e);
			}
			c.length > 0 && this.#g(e, c);
		}
		#g(e, t) {
			let n = this.#l(e);
			if (n.length === 0) return;
			let r = 0, i = Infinity;
			for (let t = 0; t < n.length; t++) {
				let a = Math.abs(this.#u(e, n[t]) - e.scrollLeft);
				a < i && (i = a, r = t);
			}
			this.getAttribute("data-index") !== String(r) && this.setAttribute("data-index", String(r));
			for (let e of t) e.getAttribute("value") === String(r) ? e.setAttribute("aria-current", "true") : e.removeAttribute("aria-current");
		}
		#_(e, t) {
			if (this.#o.has(e) || this.#o.set(e, e.getAttribute("tabindex")), t) {
				e.setAttribute("aria-disabled", "true"), e.tabIndex = -1;
				return;
			}
			e.removeAttribute("aria-disabled");
			let n = this.#o.get(e);
			n === null ? e.removeAttribute("tabindex") : n !== void 0 && e.setAttribute("tabindex", n);
		}
	}
};
function re(e, t) {
	for (let [n, r] of t) {
		let t = `${e}-${n}`;
		customElements.get(t) || customElements.define(t, r);
	}
}
function ie(e = "pd") {
	re(e, Object.entries(ne));
}
//#endregion
//#region node_modules/invokers-polyfill/invoker.js
function ae() {
	return typeof HTMLButtonElement < "u" && "command" in HTMLButtonElement.prototype && "source" in ((globalThis.CommandEvent || {}).prototype || {});
}
function oe() {
	document.addEventListener("invoke", (e) => {
		e.type == "invoke" && e.isTrusted && (e.stopImmediatePropagation(), e.preventDefault());
	}, !0), document.addEventListener("command", (e) => {
		e.type == "command" && e.isTrusted && (e.stopImmediatePropagation(), e.preventDefault());
	}, !0);
	function e(e, t, n = !0) {
		Object.defineProperty(e, t, {
			...Object.getOwnPropertyDescriptor(e, t),
			enumerable: n
		});
	}
	function t(e) {
		return e && typeof e.getRootNode == "function" ? e.getRootNode() : e && e.parentNode ? t(e.parentNode) : e;
	}
	let n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
	class i extends Event {
		constructor(e, t = {}) {
			super(e, t);
			let { source: i, command: a } = t;
			if (i != null && !(i instanceof Element)) throw TypeError("source must be an element");
			n.set(this, i || null), r.set(this, a === void 0 ? "" : String(a));
		}
		get [Symbol.toStringTag]() {
			return "CommandEvent";
		}
		get source() {
			if (!n.has(this)) throw TypeError("illegal invocation");
			let e = n.get(this);
			if (!(e instanceof Element)) return null;
			let r = t(e);
			return r === t(this.target || document) ? e : r.host;
		}
		get command() {
			if (!r.has(this)) throw TypeError("illegal invocation");
			return r.get(this);
		}
	}
	e(i.prototype, "source"), e(i.prototype, "command");
	let a = /* @__PURE__ */ new WeakMap();
	function o(e) {
		Object.defineProperties(e.prototype, {
			commandForElement: {
				enumerable: !0,
				configurable: !0,
				set(e) {
					if (e === null) this.removeAttribute("commandfor"), a.delete(this);
					else if (e instanceof Element) {
						this.setAttribute("commandfor", "");
						let n = t(e);
						t(this) === n || n === this.ownerDocument ? a.set(this, e) : a.delete(this);
					} else throw TypeError("commandForElement must be an element or null");
				},
				get() {
					if (this.localName !== "button" || this.disabled) return null;
					if (this.form && this.getAttribute("type") !== "button") return console.warn("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work"), null;
					let e = a.get(this);
					if (e) return e.isConnected ? e : (a.delete(this), null);
					let n = t(this), r = this.getAttribute("commandfor");
					return (n instanceof Document || n instanceof ShadowRoot) && r && n.getElementById(r) || null;
				}
			},
			command: {
				enumerable: !0,
				configurable: !0,
				get() {
					let e = this.getAttribute("command") || "";
					if (e.startsWith("--")) return e;
					let t = e.toLowerCase();
					switch (t) {
						case "show-modal":
						case "request-close":
						case "close":
						case "toggle-popover":
						case "hide-popover":
						case "show-popover": return t;
					}
					return "";
				},
				set(e) {
					this.setAttribute("command", e);
				}
			}
		});
	}
	let s = /* @__PURE__ */ new WeakMap();
	Object.defineProperties(HTMLElement.prototype, { oncommand: {
		enumerable: !0,
		configurable: !0,
		get() {
			return l.takeRecords(), s.get(this) || null;
		},
		set(e) {
			let t = s.get(this) || null;
			t && this.removeEventListener("command", t), s.set(this, typeof e == "object" || typeof e == "function" ? e : null), typeof e == "function" && this.addEventListener("command", e);
		}
	} });
	function c(e) {
		for (let t of e) t.oncommand = Function("event", t.getAttribute("oncommand"));
	}
	let l = new MutationObserver((e) => {
		for (let t of e) {
			let { target: e } = t;
			t.type === "childList" ? c(e.querySelectorAll("[oncommand]")) : c([e]);
		}
	});
	l.observe(document, {
		subtree: !0,
		childList: !0,
		attributeFilter: ["oncommand"]
	}), c(document.querySelectorAll("[oncommand]"));
	let u = /* @__PURE__ */ new WeakSet();
	function d(e) {
		if (u.has(e) || (u.add(e), e.defaultPrevented) || e.type !== "click") return;
		let t = e.composedPath().find((e) => e.matches?.("button[commandfor], button[command]"));
		if (!t) return;
		if (t.form && t.getAttribute("type") !== "button") throw e.preventDefault(), Error("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work. In order for it to act as a Submit button, it must not have command or commandfor attributes");
		if (t.hasAttribute("command") !== t.hasAttribute("commandfor")) {
			let e = t.hasAttribute("command") ? "command" : "commandfor", n = t.hasAttribute("command") ? "commandfor" : "command";
			throw Error(`Element with ${e} attribute must also have a ${n} attribute to function.`);
		}
		if (t.command !== "show-popover" && t.command !== "hide-popover" && t.command !== "toggle-popover" && t.command !== "show-modal" && t.command !== "request-close" && t.command !== "close" && !t.command.startsWith("--")) {
			console.warn(`"${t.command}" is not a valid command value. Custom commands must begin with --`);
			return;
		}
		let n = t.commandForElement;
		if (!n) return;
		let r = new i("command", {
			command: t.command,
			source: t,
			cancelable: !0
		});
		if (n.dispatchEvent(r), r.defaultPrevented) return;
		let a = r.command.toLowerCase();
		if (n.popover) {
			let e = !n.matches(":popover-open");
			e && (a === "toggle-popover" || a === "show-popover") ? n.showPopover({ source: t }) : !e && a === "hide-popover" && n.hidePopover();
		} else if (n.localName === "dialog") {
			let e = !n.hasAttribute("open");
			e && a == "show-modal" ? n.showModal() : !e && a == "close" ? n.close(t.value ? t.value : void 0) : !e && a == "request-close" && (HTMLDialogElement.prototype.requestClose || (HTMLDialogElement.prototype.requestClose = function() {
				let e = new Event("cancel", { cancelable: !0 });
				this.dispatchEvent(e), e.defaultPrevented || this.close();
			}), n.requestClose(t.value ? t.value : void 0));
		}
	}
	function f(e) {
		e.addEventListener("click", d, !0);
	}
	function p(e, t) {
		let n = e.prototype.attachShadow;
		e.prototype.attachShadow = function(e) {
			let r = n.call(this, e);
			return t(r), r;
		};
		let r = e.prototype.attachInternals;
		e.prototype.attachInternals = function() {
			let e = r.call(this);
			return e.shadowRoot && t(e.shadowRoot), e;
		};
	}
	o(HTMLButtonElement), p(HTMLElement, (e) => {
		f(e), l.observe(e, { attributeFilter: ["oncommand"] }), c(e.querySelectorAll("[oncommand]"));
	}), f(document), Object.assign(globalThis, { CommandEvent: i });
}
var se = t((() => {})), ce = /* @__PURE__ */ n({}), le = t((() => {
	se(), ae() || oe();
}));
(globalThis.CommandEvent === void 0 || !("commandForElement" in HTMLButtonElement.prototype)) && await Promise.resolve().then(() => (le(), ce)), ie();
//#endregion
